<template>
  <div class="landing-page">
    <!-- 首屏：黄金3秒定生死 -->
    <section class="hero-section">
      <div class="hero-bg"></div>
      <div class="hero-content">
        <h1 class="hero-title">别让口腔问题<br/>偷走你的自信笑容</h1>
        <p class="hero-subtitle">闪闪亮 专研口腔微生态，7天改善牙龈敏感，28天焕亮牙齿</p>
        <div class="hero-tags">
          <span class="tag tag-patent">🧬 专利益生菌配方</span>
          <span class="tag tag-safe">🚫 0酒精·0刺激·0荧光剂</span>
          <span class="tag tag-doctor">🏥 三甲口腔医生联合研发</span>
        </div>
        <div class="hero-form-card">
          <h3 class="form-title">🎁 新人专属：0元领取口腔健康礼包</h3>
          <van-field v-model="heroForm.name" placeholder="请输入您的姓名" class="form-input" />
          <van-field v-model="heroForm.phone" type="tel" maxlength="11" placeholder="请输入手机号" class="form-input" />
          <van-button type="primary" block class="submit-btn" @click="submitForm('hero')">立即领取</van-button>
          <p class="form-hint">已有 12,843 人领取 | 仅限前 100 名</p>
        </div>
      </div>
    </section>

    <!-- 痛点唤醒 -->
    <section class="pain-section">
      <h2 class="section-title">你是否有这些困扰？</h2>
      <div class="pain-cards">
        <div class="pain-card" v-for="item in painPoints" :key="item.title">
          <div class="pain-icon">{{ item.icon }}</div>
          <h3 class="pain-card-title">{{ item.title }}</h3>
          <p class="pain-card-desc">{{ item.desc }}</p>
        </div>
      </div>
      <p class="pain-transition">口腔问题不是小事，而是身体发出的求救信号。<br/>普通牙膏只能清洁表面，无法解决根源。</p>
    </section>

    <!-- 解决方案 -->
    <section class="solution-section">
      <h2 class="section-title">为什么选择 闪闪亮？</h2>
      <div class="solution-list">
        <div class="solution-item" v-for="(item, idx) in solutions" :key="idx">
          <div class="solution-icon-wrap">
            <span class="solution-icon">{{ item.icon }}</span>
          </div>
          <div class="solution-content">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
      <div class="compare-box">
        <div class="compare-col compare-left">
          <h4>普通牙膏</h4>
          <ul>
            <li>残留多</li>
            <li>泡沫粗糙</li>
            <li>刺激黏膜</li>
          </ul>
        </div>
        <div class="compare-vs">VS</div>
        <div class="compare-col compare-right">
          <h4>闪闪亮</h4>
          <ul>
            <li>✨ 洁净透亮</li>
            <li>☁️ 绵密泡沫</li>
            <li>🛡️ 温和包裹</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 信任背书 -->
    <section class="trust-section">
      <h2 class="section-title">他们都在用</h2>
      <div class="trust-certs">
        <div class="cert-badge" v-for="c in certs" :key="c">{{ c }}</div>
      </div>
      <div class="trust-doctor">
        <p class="doctor-quote">"作为牙医，我推荐 闪闪亮 给术后及敏感患者，它的温和度与修护力在临床测试中表现优异。"</p>
        <p class="doctor-info">—— Dr. 李 | 某三甲医院口腔科主治医师</p>
      </div>
      <div class="trust-reviews">
        <div class="review-item" v-for="r in reviews" :key="r.name">
          <div class="review-stars">⭐⭐⭐⭐⭐</div>
          <p class="review-name">{{ r.name }}</p>
          <p class="review-text">"{{ r.text }}"</p>
        </div>
      </div>
    </section>

    <!-- 底部转化 -->
    <section class="cta-section">
      <h2 class="cta-title">现在注册，开启你的口腔焕新之旅</h2>
      <div class="cta-benefits">
        <p>✅ 注册即送 ¥50 无门槛优惠券</p>
        <p>✅ 免费获取《口腔健康自测表》PDF</p>
        <p>✅ 优先体验新品试用装资格</p>
      </div>
      <div class="cta-form-card">
        <van-field v-model="ctaForm.name" placeholder="请输入您的姓名" class="form-input" />
        <van-field v-model="ctaForm.phone" type="tel" maxlength="11" placeholder="请输入手机号" class="form-input" />
        <van-button type="primary" block class="submit-btn" @click="submitForm('cta')">立即注册</van-button>
      </div>
      <p class="cta-privacy">🔒 我们承诺严格保护您的隐私，绝不骚扰。</p>
    </section>

    <!-- 底部合规信息 -->
    <footer class="landing-footer">
      <p>营业执照 | <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">吉ICP备2026007743号</a> | <a href="javascript:void(0)">隐私政策</a></p>
      <p class="footer-copy">© 2026 闪闪亮 版权所有</p>
    </footer>

    <!-- 悬浮底部表单按钮（移动端） -->
    <div class="floating-bar" v-if="showFloating">
      <van-button type="primary" block class="floating-btn" @click="scrollToForm">🎁 0元领取口腔礼包</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { createCustomerResource } from '@/api/customerResource'

export default {
  name: 'LandingPage',
  metaInfo: { title: '闪闪亮 口腔护理 — 0元领取口腔健康礼包' },
  data() {
    return {
      heroForm: { name: '', phone: '' },
      ctaForm: { name: '', phone: '' },
      showFloating: false,
      painPoints: [
        { icon: '🩸', title: '刷牙出血', desc: '牙龈红肿敏感，吃冷热酸甜都刺痛？' },
        { icon: '😷', title: '口气尴尬', desc: '社交距离不敢靠近，戴口罩都嫌自己有味？' },
        { icon: '🦷', title: '牙渍暗沉', desc: '咖啡茶渍堆积，笑容显得脏脏的没精神？' }
      ],
      solutions: [
        { icon: '🧬', title: '微生态平衡技术', desc: '不是"杀菌"，而是"养菌"。补充口腔有益菌，抑制有害菌，从根源减少牙菌斑。' },
        { icon: '🔬', title: '纳米级清洁因子', desc: '深入牙缝 0.01mm，带走 99% 食物残渣，不伤牙釉质。' },
        { icon: '💊', title: '舒缓修护因子', desc: '针对牙龈出血，48小时快速修护黏膜屏障。' }
      ],
      certs: ['SGS 检测报告', 'FDA 认证', '专利证书'],
      reviews: [
        { name: '@职场宝妈', text: '用了一周，早上刷牙终于不出血了，口气也清新很多，回购第三支！' },
        { name: '@咖啡重度爱好者', text: '去渍效果肉眼可见，而且不酸牙，会一直用下去。' }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.showFloating = window.scrollY > 600
    },
    scrollToForm() {
      const el = document.querySelector('.hero-form-card')
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    validatePhone(phone) {
      return /^1[3-9]\d{9}$/.test(phone)
    },
    async submitForm(type) {
      const form = type === 'hero' ? this.heroForm : this.ctaForm
      if (!form.name || form.name.trim().length < 1) {
        Toast('请输入您的姓名')
        return
      }
      if (!this.validatePhone(form.phone)) {
        Toast('请输入正确的手机号')
        return
      }
      try {
        await landingRegister({ name: form.name.trim(), phone: form.phone, source: 'landing_' + type })
        Toast.success('提交成功！我们会尽快联系您')
        form.name = ''
        form.phone = ''
      } catch (e) {
        Toast.fail('提交失败，请稍后重试')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.landing-page {
  background: #fff;
  overflow-x: hidden;
}

/* 通用 */
.section-title {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  padding: 32px 20px 16px;
  color: var(--text-primary);
}

/* ===== 首屏 Hero ===== */
.hero-section {
  position: relative;
  min-height: 100vh;
  padding: 48px 20px 32px;
  background: linear-gradient(165deg, #e8f6f0 0%, #f0faff 40%, #eef4ff 100%);
  overflow: hidden;
}
.hero-bg {
  position: absolute;
  top: -60px;
  right: -40px;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(46,196,182,0.15) 0%, transparent 70%);
  pointer-events: none;
}
.hero-content {
  position: relative;
  z-index: 1;
}
.hero-title {
  font-size: 26px;
  font-weight: 800;
  line-height: 1.4;
  color: #1a2a3a;
  margin-bottom: 12px;
}
.hero-subtitle {
  font-size: 15px;
  color: #4a6070;
  line-height: 1.6;
  margin-bottom: 20px;
}
.hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
}
.tag {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}
.tag-patent {
  background: #e0f5ef;
  color: #1a8a6e;
}
.tag-safe {
  background: #fff3e8;
  color: #c0651a;
}
.tag-doctor {
  background: #e8f0ff;
  color: #2a6fcc;
}

/* 表单卡片 */
.hero-form-card,
.cta-form-card {
  background: #fff;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.form-title {
  font-size: 17px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 14px;
  color: #1a2a3a;
}
.form-input {
  background: #f5f7fa;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 10px 14px;
}
.submit-btn {
  margin-top: 12px;
  height: 48px;
  border-radius: 24px;
  font-size: 17px;
  font-weight: 700;
  background: linear-gradient(135deg, #2ec4b6 0%, #1a9a8e 100%) !important;
  border: none !important;
}
.form-hint {
  text-align: center;
  font-size: 12px;
  color: #a0a4ae;
  margin-top: 10px;
}

/* ===== 痛点区 ===== */
.pain-section {
  background: #f7f9fc;
  padding: 0 0 24px;
}
.pain-cards {
  display: flex;
  gap: 12px;
  padding: 0 16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.pain-card {
  flex: 0 0 auto;
  width: calc(50vw - 22px);
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
}
.pain-card:last-child {
  margin-right: 16px;
}
.pain-icon {
  font-size: 36px;
  margin-bottom: 8px;
}
.pain-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a2a3a;
  margin-bottom: 6px;
}
.pain-card-desc {
  font-size: 13px;
  color: #666b78;
  line-height: 1.5;
}
.pain-transition {
  margin: 20px 20px 0;
  padding: 16px;
  background: linear-gradient(135deg, #fef3e2, #fff0e0);
  border-radius: 10px;
  font-size: 13px;
  color: #8a5a1a;
  line-height: 1.6;
  text-align: center;
  font-weight: 500;
}

/* ===== 解决方案 ===== */
.solution-section {
  background: #fff;
  padding-bottom: 8px;
}
.solution-list {
  padding: 0 20px;
}
.solution-item {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
}
.solution-item:last-child {
  border-bottom: none;
}
.solution-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #f0f7f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.solution-icon {
  font-size: 22px;
}
.solution-content {
  h3 {
    font-size: 16px;
    font-weight: 700;
    color: #1a2a3a;
    margin-bottom: 4px;
  }
  p {
    font-size: 13px;
    color: #666b78;
    line-height: 1.6;
  }
}

/* 对比 */
.compare-box {
  display: flex;
  margin: 16px 20px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}
.compare-col {
  flex: 1;
  padding: 18px 14px;
  text-align: center;
}
.compare-left {
  background: #fff5f5;
  h4 { font-size: 15px; color: #c44; font-weight: 700; margin-bottom: 8px; }
  ul { list-style: none; padding: 0; li { font-size: 13px; color: #a66; padding: 4px 0; } }
}
.compare-right {
  background: #f0faf5;
  h4 { font-size: 15px; color: #1a8a6e; font-weight: 700; margin-bottom: 8px; }
  ul { list-style: none; padding: 0; li { font-size: 13px; color: #2a9a7e; padding: 4px 0; } }
}
.compare-vs {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6fa;
  font-size: 14px;
  font-weight: 800;
  color: #a0a4ae;
  width: 40px;
}

/* ===== 信任背书 ===== */
.trust-section {
  background: #f7f9fc;
  padding-bottom: 16px;
}
.trust-certs {
  display: flex;
  gap: 10px;
  padding: 0 20px;
  flex-wrap: wrap;
}
.cert-badge {
  padding: 6px 14px;
  border-radius: 20px;
  background: #fff;
  border: 1px solid #e0e8f0;
  font-size: 12px;
  font-weight: 600;
  color: #4a6070;
}
.trust-doctor {
  margin: 16px 20px;
  padding: 18px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
.doctor-quote {
  font-size: 14px;
  color: #1a2a3a;
  line-height: 1.7;
  font-style: italic;
  margin-bottom: 8px;
}
.doctor-info {
  font-size: 12px;
  color: #2a6fcc;
  font-weight: 600;
}
.trust-reviews {
  padding: 0 20px;
}
.review-item {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 10px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
}
.review-stars {
  font-size: 12px;
  margin-bottom: 4px;
}
.review-name {
  font-size: 13px;
  color: #2a6fcc;
  font-weight: 600;
  margin-bottom: 4px;
}
.review-text {
  font-size: 13px;
  color: #4a6070;
  line-height: 1.5;
}

/* ===== 底部转化 ===== */
.cta-section {
  background: linear-gradient(180deg, #e8f6f0 0%, #f0faff 100%);
  padding: 32px 20px 24px;
}
.cta-title {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  color: #1a2a3a;
  margin-bottom: 16px;
}
.cta-benefits {
  margin-bottom: 18px;
  p {
    font-size: 14px;
    color: #1a6a5a;
    padding: 4px 0;
    font-weight: 500;
  }
}
.cta-privacy {
  text-align: center;
  font-size: 12px;
  color: #a0a4ae;
  margin-top: 12px;
}

/* ===== Footer ===== */
.landing-footer {
  background: #1a2a3a;
  padding: 20px;
  text-align: center;
  p {
    font-size: 12px;
    color: #8a9aaa;
    line-height: 1.8;
  }
  a {
    color: #8ab8e8;
    text-decoration: underline;
  }
  .footer-copy {
    color: #5a6a7a;
    margin-top: 4px;
  }
}

/* ===== 悬浮按钮 ===== */
.floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
  z-index: 100;
}
.floating-btn {
  height: 48px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 700;
  background: linear-gradient(135deg, #2ec4b6 0%, #1a9a8e 100%) !important;
  border: none !important;
}
</style>
